import { InjectionToken } from '@angular/core';

/**
 * Per-app properties attached to every `$exception` the error handler reports. A factory rather than
 * a value, because what identifies the session (the acting profile) resolves after the app boots.
 */
export const POSTHOG_EXCEPTION_CONTEXT = new InjectionToken<() => Record<string, unknown>>('POSTHOG_EXCEPTION_CONTEXT');
